module.exports = __webpack_public_path__ + "static/images/refund_s.66a2ae90073ea1db08f41b45883cb972.png";